import React, { useContext, useCallback } from "react";
import TextField from "component/textField/TextField";
import MaintenanceTaskContext from "module/maintenanceTask/context/MaintenanceTaskContext";
import MaintenanceTaskChangeContext from "module/maintenanceTask/change/MaintenanceTaskChangeContext";
import MaintenanceTaskFieldMetaDataContext from "module/maintenanceTask/validation/fieldMetaData/MaintenanceTaskFieldMetaDataContext";
import { MaintenanceTaskInterface } from "module/maintenanceTask/types";
import { getFieldMetaDataWithErrorHandling } from "module/fieldMetaData/getFieldMetaData";
import { MAINTENANCE_TASK_ASSISTANT_EXTERNAL_STAFF_NAME_FIELD_NAME } from "module/maintenanceTask/constants";
import XLabelField from "component/labelField/XLabelField";

const MaintenanceTaskAssistantExternalStaffNameContainer: React.FC = () => {
  const { entity } = useContext(MaintenanceTaskContext);
  const { change: changeHelper } = useContext(MaintenanceTaskChangeContext);
  const { getFieldMetaData } = useContext(MaintenanceTaskFieldMetaDataContext);

  const maintenanceTask = entity as MaintenanceTaskInterface;

  const { warnings, errors, isEditable } = getFieldMetaDataWithErrorHandling(
    () =>
      getFieldMetaData(
        MAINTENANCE_TASK_ASSISTANT_EXTERNAL_STAFF_NAME_FIELD_NAME
      )
  );

  const change = useCallback(
    (assistantExternalStaffName?: string) => {
      changeHelper({ assistantExternalStaffName });
    },
    [changeHelper]
  );

  return isEditable ? (
    <TextField
      {...{
        value: maintenanceTask.assistantExternalStaffName,
        change,
        errors,
      }}
    />
  ) : (
    <XLabelField
      {...{
        label: maintenanceTask.assistantExternalStaffName,
        errors,
        warnings,
      }}
    />
  );
};

export default React.memo(MaintenanceTaskAssistantExternalStaffNameContainer);
